import Accordion from '@mui/material/Accordion';
import AccordionSummary from '@mui/material/AccordionSummary';
import AccordionDetails from '@mui/material/AccordionDetails';
import Typography from '@mui/material/Typography';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import React, { useState, useEffect } from 'react'
import LiveNotation from './notation/LiveNotation.js';
import { Grid, Paper } from '@mui/material';
import { Box } from '@mui/system';
import { useSelector } from 'react-redux';
import LiveArticle from './article/LiveArticle.js';
import Survey from './sondage/LiveSondage.js';
import Quizz from './quizz/LiveQuizz.js';
import MatchesBasketCSV from './../../../components/admin/csv/MatchesBasketCSV.js';
import { getUserProvider } from '../../../actions/auth.js';
import { isAdminUser } from '../../../actions/auth.js';

const LiveImport = ({match, liveId}) => {
    
  const [expanded, setExpanded] = React.useState(false);
  const [provider, setProvider] = useState('');

   // Effet secondaire pour initialiser le provider après le rendu initial
   useEffect(() => {
    setProvider(getUserProvider());
  }, []); 

  const handleChange = (panel) => (event, isExpanded) => {
    setExpanded(isExpanded ? panel : false);
  };

  const getLiveUrl = () => {
    //url live
    const urlLocation = process.env.REACT_APP_LIVE_CLIENT_URL;
    const url = urlLocation + "/actualite/"+liveId;
    return url;
  }

  const display = match.type==='match' ? 'block' : 'inline-grid' ;

    return (
      <Box sx={{ display: display }}>
        <Grid container spacing={2}>
          <Grid item xs={12} md={match.type === 'actu' ? 8 : 12}>
            {/* Accordéons */}
            {match.type=== 'match' && <Accordion expanded={expanded === 'notation'} onChange={handleChange('notation')}>
      <AccordionSummary
        expandIcon={<ExpandMoreIcon />}
        aria-controls="panel1a-content"
        id="panel1a-header"
      >
        <Typography>Notation</Typography>
      </AccordionSummary>
      <AccordionDetails>
        <Typography>
        Le widget "notation" permet à vos internautes de noter le match, une équipe et un ou plusieurs joueur(s).
            <Box textAlign={'center'} paddingTop='20px'>
                <LiveNotation match={match} onSubmit={() => {}}/>
            </Box>
          
        </Typography>
      </AccordionDetails>
    </Accordion>}
    {match.type=== 'actu' && <Accordion expanded={expanded === 'notation'} onChange={handleChange('notation')}>
      <AccordionSummary
        expandIcon={<ExpandMoreIcon />}
        aria-controls="panel1a-content"
        id="panel1a-header"
      >
        <Typography>Notation</Typography>
      </AccordionSummary>
      <AccordionDetails>
        <Typography>
          <Box sx={{backgroundColor:'#80808021'}}>
          Le widget "notation" permet à vos internautes de noter leur compréhension et leurs connaissances sur le sujet traité.
          </Box>
            <Box textAlign={'center'} paddingTop='20px'>
                <LiveNotation match={match} onSubmit={() => {}} type={'actu'}/>
            </Box>
          
        </Typography>
      </AccordionDetails>
    </Accordion>}
    <Accordion expanded={expanded === 'article'} onChange={handleChange('article')}>
      <AccordionSummary
        expandIcon={<ExpandMoreIcon />}
        aria-controls="panel1a-content"
        id="panel1a-header"
      >
        <Typography>Intégration : article, contenu réseaux sociaux (X, instagram, facebook, youtube ...), image, url, iframe</Typography>
      </AccordionSummary>
      <AccordionDetails>
        <Typography>
            <Box textAlign={'center'} paddingTop='20px'>
                <LiveArticle match={match} onSubmit={() => {}}/>
            </Box>
          
        </Typography>
      </AccordionDetails>
    </Accordion>
    <Accordion>
      <AccordionSummary
        expandIcon={<ExpandMoreIcon />}
        aria-controls="panel2a-content"
        id="panel2a-header"
      >
        <Typography>Sondage</Typography>
      </AccordionSummary>
      <AccordionDetails>
        <Typography>
            <Box textAlign={'center'} paddingTop='20px'>
                <Survey match={match} onSubmit={() => {}}/>
            </Box>
        </Typography>
      </AccordionDetails>
    </Accordion>
    <Accordion>
      <AccordionSummary
        expandIcon={<ExpandMoreIcon />}
        aria-controls="panel3a-content"
        id="panel3a-header"
      >
        <Typography>Quiz</Typography>
      </AccordionSummary>
      <AccordionDetails>
        <Typography>
            <Box textAlign={'center'} paddingTop='20px'>
                <Quizz match={match} onSubmit={() => {}}/>
            </Box>
        </Typography>
      </AccordionDetails>
    </Accordion>

{/*Results Import CSV*/}
{match && match.competition && <Accordion expanded={expanded === 'import_csv'} onChange={handleChange('import_csv')}>
      <AccordionSummary
        expandIcon={<ExpandMoreIcon />}
        aria-controls="panel1a-content"
        id="panel1a-header"
      >
        <Typography>Import: joueurs et faits de jeux</Typography>
      </AccordionSummary>
      <AccordionDetails>
        <Typography>
            <Box textAlign={'center'} paddingTop='20px'>
            {<MatchesBasketCSV importOption='copy-paste' provider={provider} discipline={match.competition.discipline} match={match} />}
            </Box>
          
        </Typography>
      </AccordionDetails>
    </Accordion>}
    <Accordion disabled>
      <AccordionSummary
        expandIcon={<ExpandMoreIcon />}
        aria-controls="panel3a-content"
        id="panel3a-header"
      >
        <Typography>Template</Typography>
      </AccordionSummary>
    </Accordion>
          </Grid>
    
          {match.type === 'actu' && (
            <Grid item xs={12} md={4}>
              {/* Colonne de droite avec l'iframe */}
              <Box  sx={{ border:'1px solid #dadada'}}>

              <Typography
                sx={{
                  display: 'flex',
                  alignItems: 'center',
                  backgroundColor: '#000000c9',
                  color: 'white',
                  padding: '0.25rem',
                  textTransform: 'uppercase',
                  fontSize: 'small',
                }}
              >
                {/* Rond rouge à gauche */}
                <Box
                  sx={{
                    width: '10px',
                    height: '10px',
                    backgroundColor: '#e61515',
                    borderRadius: '50%',
                    marginRight: '8px', // Espace entre le rond et le texte
                    marginLeft: '5px',
                  }}
                />
                Live preview
              </Typography>

              <Box sx={{ position: 'relative', height: '500px', width: '100%' }}>
                {/* Iframe pour l'aperçu */}
                <iframe
                  src={getLiveUrl()}
                  title="Aperçu"
                  width="100%"
                  height="100%"
                  style={{
                    border: 'none',
                    minHeight: '500px',
                    overflow: 'auto',
                  }}
                />

                {/* Superposition transparente pour bloquer les interactions */}
                <Box
                  sx={{
                    position: 'absolute',
                    top: 0,
                    left: 0,
                    right: 0,
                    bottom: 0,
                    zIndex: 10, // S'assurer que la superposition est bien au-dessus
                    backgroundColor: 'rgba(0, 0, 0, 0)',  // Transparente
                    pointerEvents: 'auto',  // Bloquer les événements en capturant les clics
                    height: '90%',
                    width: '65%',
                  }}
                />
              </Box>

              </Box>
             
            </Grid>
          )}
        </Grid>
      </Box>
    );
}

export default LiveImport